import { LifecycleState } from 'api/GraphQL/queries/getVehicleSummaries';

/**
 * Determines the hero heading text based on lifecycle status and user's given name
 * @param givenName - User's first name (optional)
 * @param lifecycleState - The lifecycle status from the first vehicle summary
 * @returns The appropriate heading text
 */
export const getHeroHeading = (
  givenName: string | undefined,
  lifecycleState: LifecycleState | undefined
): string => {
  // Handle case there's no summary
  if (!lifecycleState) {
    return 'Get a real offer in\u00A02\u00A0minutes';
  }

  // Determine heading based on lifecycle status
  switch (lifecycleState) {
    case LifecycleState.Active:
      return givenName ? `${givenName}, your offer is ready` : 'Your offer is ready';

    case LifecycleState.Scheduled:
    case LifecycleState.AppliedToPurchase:
    case LifecycleState.Complete:
      return givenName ? `Welcome back, ${givenName}` : 'Welcome back';

    case LifecycleState.Expired:
      return givenName ? `${givenName}, let's refresh your offer` : 'Let\u2019s refresh your offer';

    case LifecycleState.Rejected:
    case LifecycleState.NeedsManualAppraisal:
      return givenName ? `${givenName}, let's get your offer` : 'Let\u2019s get your offer';

    // Default case for any other lifecycle states
    default:
      return givenName ? `${givenName}, your offer is ready` : 'Your offer is ready';
  }
};
